/**
 * CLI error types.
 *
 * Both carry the Effect runtime markers that `BunRuntime.runMain` reads via
 * `defaultTeardown`:
 *   - `Runtime.errorExitCode` → the process exit code on failure.
 *   - `Runtime.errorReported` → `false` suppresses runMain's own error log (we
 *     print our own clean output first). `makeRunMain` logs only when this reads
 *     `true`, which is the default, so unexpected/defect errors still surface.
 *
 * This is the seam that lets every command own its output and still set a
 * meaningful exit code. See `output.ts`.
 *
 * @module
 */
import { Data, Runtime } from "effect"

/** An operation ran but its result was a failure (e.g. validation failed). Exit 1. */
export class OperationFailed extends Data.TaggedError("OperationFailed")<{
  /** Names of the checks/steps that failed, for diagnostics. */
  readonly failed: ReadonlyArray<string>
}> {
  readonly [Runtime.errorExitCode] = 1
  readonly [Runtime.errorReported] = false
}

/** The command could not run as asked (bad path, unreadable project, bad flag). Exit 2. */
export class UsageError extends Data.TaggedError("UsageError")<{
  readonly reason: string
}> {
  readonly [Runtime.errorExitCode] = 2
  readonly [Runtime.errorReported] = false
}
